// @flow

/* eslint-disable no-unused-vars */

import React from 'react';
import moment from 'moment';



/**
 * Returns web element to be rendered.
 *
 * @param {string} timerValue - String to display as time.
 * @param {Object} textStyle - Unused on web.
 *
 * @returns {ReactElement}
 */
export default function renderConferenceTimer(timerValue: string, textStyle: Object) {
    // Implementation of timer so that Screen Readers could read it as an amount of time not as a time
    const [hours,minutes, seconds] = timerValue.split(':').map(Number);
    const timeInSeconds = (hours * 3600)+(minutes * 60) + seconds;
    const timerV =  moment.duration(timerValue).format('h:m:s', {trim :true})

    const hour = Math.floor(timeInSeconds / 3600);
    const minute = Math.floor(timeInSeconds / 60);
    const second = timeInSeconds % 60;

    let accessTimestring = "";
    if (hour > 0) {
      accessTimestring = `${hour} 시간 `;
    }
    if (minute > 0) {
      accessTimestring += `${minute} 분 `;
    }
    accessTimestring += `${second} 초`;

    return (
        <span className = 'subject-timer'
         tabIndex={1}
         aria-label={accessTimestring}
         aria-hidden={true}
         role="timer">{ timerV }</span>
    );
}
